import { invoicesConstants } from '../constants';

export function invoicesReducers(state = {}, action) {
    switch (action.type) {
            
        // Get General Invoices
        
        case invoicesConstants.getGeneralInvoices_request:
            return {
                ...state,
                getGeneralInvoices_requesting: true, getGeneralInvoices_status: false,
            }
        case invoicesConstants.getGeneralInvoices_success:
            return {
                ...state,
                getGeneralInvoices_requesting: false, getGeneralInvoices_status: true,
                generalInvoiceList: action.details.data,
                generalInvoiceListHeaders: action.details.headers, 
            }
        case invoicesConstants.getGeneralInvoices_failure:
            return {
                ...state,
                getGeneralInvoices_requesting: false, getGeneralInvoices_status: false, 
            }

        // Get Company Invoices
        
        case invoicesConstants.getCompanyInvoices_request:
            return {
                ...state,
                getCompanyInvoices_requesting: true, getCompanyInvoices_status: false,
            }
        case invoicesConstants.getCompanyInvoices_success:
            return {
                ...state,
                getCompanyInvoices_requesting: false, getCompanyInvoices_status: true,
                companyInvoiceList: action.details.data,
                companyInvoiceListHeaders: action.details.headers, 
            }
        case invoicesConstants.getCompanyInvoices_failure:
            return {
                ...state,
                getCompanyInvoices_requesting: false, getCompanyInvoices_status: false, 
            }

        default:
            return state;
    }
}